import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'railcar';

const mapStateToProps = (state, ownProps) => {
	let railcars;
	let railcar;
	let railcarId;

	if (state.lists.railcarIds) {
		railcars = _.map(state.lists.railcarIds, (id) => state.maps.railcar[id]);
	}

	if (ownProps.railcar) {
		railcar = ownProps.railcar;
	} else {
		railcarId = ownProps.railcarId
			? ownProps.railcarId
			: _.get(ownProps, ['match', 'params', 'railcarId']);
		railcar = _.get(state.maps, ['railcar', railcarId]);
	}

	return {
		railcar,
		railcars,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		terminalMap: state.maps.terminal,
		// resourceMap: state.maps.resource,
		supplierMap: state.maps.supplier,
		// quickbooksItemMap: state.maps.quickbooksItem,
	};
};

const search = (p = {}) => {
	const { params = {}, callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params,
			dispatch,
			callback,
		});
	};
};

const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

const hide = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.hide`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			railcarGet: get,
			railcarSearch: search,
			railcarHide: hide,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
